import React, { forwardRef } from 'react';
import MUIAutocomplete, {
  AutocompleteProps as MUIAutocompleteProps,
} from '@material-ui/lab/Autocomplete';

import OutlinedInput from '../OutlinedInput';

export interface AutocompleteProps<
  T,
  Multiple extends boolean | undefined,
  DisableClearable extends boolean | undefined,
  FreeSolo extends boolean | undefined
> extends MUIAutocompleteProps<T, Multiple, DisableClearable, FreeSolo> {}

const Autocomplete = forwardRef(function Autocomplete(
  props: Omit<
    AutocompleteProps<
      any,
      boolean | undefined,
      boolean | undefined,
      boolean | undefined
    >,
    'renderInput'
  >,
  ref: React.Ref<HTMLDivElement>
) {
  return (
    <MUIAutocomplete
      {...props}
      ref={ref}
      disablePortal
      renderInput={({ InputProps, InputLabelProps, ...params }) => (
        <OutlinedInput
          {...params}
          autoFocus
          ref={InputProps.ref}
          inputProps={params.inputProps}
        />
      )}
    />
  );
});

Autocomplete.displayName = 'Autocomplete';

export default Autocomplete;
